import apiCompetitions from '@/api/competition'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteCompetitionStart: '[delete competition] Delete competition start',
  deleteCompetitionSuccess: '[delete competition] Delete competition success',
  deleteCompetitionFailure: '[delete competition] Delete competition failure'
}

export const actionTypes = {
  deleteCompetition: '[delete competition] Delete competition'
}

const mutations = {
  [mutationTypes.deleteCompetitionStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteCompetitionSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteCompetitionFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteCompetition](context, {id}) {
    context.commit(mutationTypes.deleteCompetitionStart)
    return new Promise(resolve => {
      apiCompetitions
        .deleteCompetition(id)
        .then(response => {
          context.commit(mutationTypes.deleteCompetitionSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteCompetitionFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
